// Cross-controller browser events. Keep names centralized so publishers and
// subscribers cannot silently drift apart during map/tracker refactors.
export const WEB_EVENTS = Object.freeze({
  flyTo: "gr8tracks:flyto",
  position: "gr8tracks:position",
  queryTracking: "gr8tracks:query-tracking",
  settings: "gr8tracks:settings",
  tracking: "gr8tracks:tracking",
  tripEnded: "gr8tracks:trip-ended",
  usgsSite: "gr8tracks:usgs-site"
})
